import { createContext } from 'react';
import { UrlHelper } from '../helpers';
export var BaseRouter;
(function (BaseRouter) {
    BaseRouter.initialState = {
        children: null,
        isLoading: true,
    };
    BaseRouter.Context = createContext(BaseRouter.initialState);
    BaseRouter.getFrontendUrl = function (login, fintechUrl, companyId, language, selectedAmount, forceLoanList, forcePTSD2Connect, forceSettings) {
        if (forceLoanList === void 0) { forceLoanList = false; }
        if (forcePTSD2Connect === void 0) { forcePTSD2Connect = false; }
        if (forceSettings === void 0) { forceSettings = false; }
        if (!login)
            return '';
        var url = UrlHelper.getUrl('auth/login/forward', fintechUrl);
        url.searchParams.set('access_token', login.accessToken.access_token);
        if (companyId)
            url.searchParams.set('company_id', companyId.toString());
        url.searchParams.set('language', language);
        if (selectedAmount)
            url.searchParams.set('selected_amount', selectedAmount.toString());
        if (forceLoanList)
            url.searchParams.set('force_loan_list', 'true');
        if (forcePTSD2Connect)
            url.searchParams.set('force_psd2_connect', 'true');
        if (forceSettings)
            url.searchParams.set('force_settings', 'true');
        return url.href;
    };
    BaseRouter.getIntegrationFrontendUrl = function (integration, fintechUrl, accessToken, connectionId, language) {
        var url = UrlHelper.getUrl("auth/login/integration/" + integration, fintechUrl);
        url.searchParams.set('access_token', accessToken);
        url.searchParams.set('language', language);
        url.searchParams.set('connection_id', connectionId);
        return url.href;
    };
    BaseRouter.getIntegrationFrontendUrlWithoutConnectionId = function (integration, fintechUrl, accessToken, language) {
        var url = UrlHelper.getUrl("auth/login/integration/" + integration, fintechUrl);
        url.searchParams.set('access_token', accessToken);
        url.searchParams.set('language', language);
        return url.href;
    };
    BaseRouter.goToFrontend = function (login, fintechUrl, companyId, languaage, selectedAmount) {
        window.location.href = BaseRouter.getFrontendUrl(login, fintechUrl, companyId, languaage, selectedAmount);
    };
})(BaseRouter || (BaseRouter = {}));
//# sourceMappingURL=router.provider.js.map